import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProfileScreen from "../modules/orbit-module/screens/profile-screen";
import CommunityScreen from "../modules/orbit-module/screens/community-screen";
import SolarSystem from "../modules/demo-module/components/3d-components/solar-system";
import OrbitHomeScreen from "../modules/demo-module/screen/orbir-home-screen";
import SyPin from "../shared/components/sy-pin";

import PlanetScreen from "../modules/orbit-module/screens/planet-screen";
import OrbitScreen from "../modules/orbit-module/screens/orbit-screen";
import AdminScreen from "../modules/orbit-module/screens/admin-screen";
import AppScreen from "../modules/orbit-module/screens/app-layout-screen";
import AppOrbitList from "../modules/orbit-module/screens/app-layout-screen/app-orbit-list";

function AppRoutes() {
  // const authToken = useSelector(getAuthToken);

  return (
    <Router>
      {/* {authToken ? ( */}
      <Routes>
        <>
          <Route path="/" element={<AppScreen />}>
            <Route index element={<AppOrbitList />} />
            <Route path="/add/:encryptData" element={<AppOrbitList />} />
            <Route path="/invite/:inviteEncryptData" element={<AppOrbitList />} />
            {/* <Route path="/add/:companyId" element={<AppOrbitList />} />
            <Route path="/invite/:userId/:companyId" element={<AppOrbitList />}/> */}
            <Route path="/admin/:orbitId/:adminView" element={<AdminScreen />} />
            <Route
              path="/view/planet/:orbitId/:planetId"
              element={<CommunityScreen />}
            />

            <Route path="/orbit" element={<OrbitScreen />} />
            <Route path="/:home/orbit" element={<OrbitScreen />} />

            <Route path="/add/planet/:id" element={<PlanetScreen />} />

            <Route path="/profile/:profileId" element={<ProfileScreen />} />
            <Route path="community" element={<CommunityScreen />} />

            <Route path="solar" element={<SolarSystem />} />
            <Route path="screen" element={<OrbitHomeScreen />} />
            <Route path="pin" element={<SyPin />} />
          </Route>
        </>
      </Routes>
      {/* ) : (
        <Routes>
          <>
          <Route path="/login" element={<LoginScreen />} />
            <Route path="*" element={<LoginScreen />} />

          </>
        </Routes>
      )} */}
    </Router>
  );
}

export default AppRoutes;
